export const ROUTE_PARAMS = {
  token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJkYXRhIjp7ImRhdGVDcmVhdGVkIjoiMjAyMy0wNi0wOVQxMDowMDowMFoiLCJsb2NhdGlvbiI6IlBhcmlzIiwib3MiOiJpT1MiLCJzb3VyY2UiOiJpUGhvbmUgMTMifSwiZXhwIjoxNzAxOTM4MDE4fQ.quizgw61p4gX_B2Liz-WdoJlWadTx9kHMPKoEV_5tHI',
  email: 'john@example.com',
  reset_password_token: 'reerereskjlmkdlsf',
  reset_token_expiration_timestamp: 45465546445,
}
